import { connect } from 'react-redux';
import Notification from 'components/Notification/Notification';
import _get from 'lodash/get';
import { removeNotification } from 'actions/Notification';

const mapActionCreators = dispatch => ({
  removeNotification: id => dispatch(removeNotification(id))
});

/* Note: I am passing nextId as a prop to force the component to update. Otherwise, the component
 * does not seem to see the changes within the array */
const mapStateToProps = (state) => {
  // show disconnection message if our network is online (another modal shows when it is offline)
  return {
    notifications: _get(state, 'app.notification.notifications'),
  };
};

export default connect(mapStateToProps, mapActionCreators)(Notification);
